namespace GeniuzPOS.Common {
    export namespace DashboardPageService {
        export const baseUrl = 'Dashboard/DashboardPage';

        export declare function CountByStatus(request: CountByStatusRequest, onSuccess?: (response: CountByStatusResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            CountByStatus = "Dashboard/DashboardPage/CountByStatus"
        }

        [
            'CountByStatus'
        ].forEach(x => {
            (<any>DashboardPageService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
